__turbopack_context__.v({
  "first": "range-module-scss-module__bso-Sa__first",
  "input": "range-module-scss-module__bso-Sa__input",
  "primary": "range-module-scss-module__bso-Sa__primary",
  "range": "range-module-scss-module__bso-Sa__range",
  "range-wrapper": "range-module-scss-module__bso-Sa__range-wrapper",
  "second": "range-module-scss-module__bso-Sa__second",
  "secondary": "range-module-scss-module__bso-Sa__secondary",
  "step": "range-module-scss-module__bso-Sa__step",
  "steps-wrapper": "range-module-scss-module__bso-Sa__steps-wrapper",
  "text": "range-module-scss-module__bso-Sa__text",
  "track": "range-module-scss-module__bso-Sa__track",
});
